import React, { useState, useEffect } from "react";
import ReportClasses from "./report.module.css";
import Loader from "Components/loader/loader";
import { IoInformationCircleSharp } from "react-icons/io5";
import { useForm } from "react-hook-form";
import moment from "moment";
import { warningSwal } from "Util/Toast";
import { Services } from "Services";
import ReactPaginate from "react-paginate";
import Moment from "react-moment";
import Select from "react-select";

import { useSearchParams } from "react-router-dom";
import Layout from "Components/Layout";
function Report() {
    const [loading, setLoading] = useState(false);
    const [showPaginate, setShowPagiate] = useState(false);
    const [pageCount, setpageCount] = useState(1);

    const itemsPerPage = 30;

    const [data, setData] = useState([]);
    const [Active, setActive] = useState("TUTOR");
    const [tutorSearchLoad, setTutorSearchLoad] = useState(false);

    const [forcepage, setforcepage] = useState(0);
    const [tutorSearchString, setTutorSearchString] = useState("");
    const [selectedTutor, setSelectedTutor] = useState(null);
    const [tutors, setTutors] = useState([]);
    const [link, setLink] = useState("");
    const [currentItems, setCurrentItems] = useState([]);

    const token = {
        Authorization: `token ${localStorage.getItem("token")}`,
    };

    const {
        register,
        handleSubmit,
        watch,
        setValue,
        reset,
        formState: {},
    } = useForm();
    const WatchData = watch();
    const formData = watch();
    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    async function getBatchRequests(skip, data) {
        try {
            let body = {
                EndDate: data?.EndDate,
                StartDate: data?.StartDate,
            };

            if (selectedTutor?.value) {
                body = { ...body, TutorID: selectedTutor?.value };
                // console.log(DateDifference);
            }
            console.log(body);
            const response = await Services.getCancelReport(
                "POST",
                JSON.stringify(body),
                token
            );

            setTimeout(() => {
                setLoading(false);
            }, 200);
            if (response?.Status == 1) {
                setData(
                    response.Results.sort(
                        (a, b) =>
                            new Date(b.Scheduled_StartDate) -
                            new Date(a.Scheduled_StartDate)
                    )
                );

                setLink(response?.CsvFile);
                setTotalPages(
                    Math.ceil(response.Results.length / itemsPerPage)
                );
            }
        } catch (err) {
            console.log(err);
            setLoading(false);
            Error("something went wrong please try again");
        }
    }
    useEffect(() => {
        const debouncedSearch = setTimeout(async () => {
            if (
                typeof tutorSearchString == "string" &&
                tutorSearchString?.length > 0
            ) {
                setTutorSearchLoad(true);

                try {
                    const data = await Services.searchActiveTutor(
                        "POST",
                        JSON.stringify({ SearchString: tutorSearchString }),
                        token,
                        selectedTutor
                    );
                    const formattedOptions = data.Tutors?.filter(
                        (item) => item.TutorStatus == 1
                    )?.map((tutor) => ({
                        label: `${tutor.FirstName} ${tutor.LastName}`,
                        value: tutor.TutorID,
                        Email: tutor.EmailID,
                    }));
                    setTutors([
                        { value: "All", label: "All", Email: "all" },
                        ...formattedOptions,
                    ]);
                } catch (error) {
                    console.error("Error fetching options:", error);
                } finally {
                    setTutorSearchLoad(false);
                }
            }
        }, 300);

        return () => clearTimeout(debouncedSearch);
    }, [tutorSearchString]);

    useEffect(() => {
        setCurrentItems(
            data.slice(
                currentPage * itemsPerPage,
                (currentPage + 1) * itemsPerPage
            )
        );
    }, [currentPage, data]);
    const onSubmit = async (data) => {
        if (moment(data.StartDate).isAfter(data.EndDate)) {
            warningSwal("Warning", "Invalid Date range");
            return;
        }
        setActive(data.Type);
        setforcepage(0);
        let fromDate = moment(data.StartDate);
        let toDate = moment(data.EndDate);
        let DateDifference = toDate.diff(fromDate, "days") + 1;
        console.log(DateDifference);
        if (DateDifference > 15 && !selectedTutor?.value) {
            warningSwal(
                "Warning",
                "Class taken report  for all tutors should be limited to 15 days"
            );
            return;
        }
        if (DateDifference > 31 && selectedTutor?.value) {
            warningSwal(
                "Warning",
                "Class taken report for Tutor should be limited to 31 days"
            );
            return;
        }
        setLoading(true);
        getBatchRequests(0, data);
    };

    const onTutorSelect = (searchString) => {
        setSelectedTutor(searchString);
    };
    const handleTutorChange = (searchString) => {
        setTutorSearchString(searchString);
    };
    const handlePageChange = (pageNumber) => {
        window.scrollTo({ top: 10, behavior: "smooth" });
        setCurrentPage(pageNumber.selected);
    };

    console.log(
        currentPage,
        currentPage * itemsPerPage,
        (currentPage + 1) * itemsPerPage
    );
    return (
        <Layout Active={"Class Taken Report"}>
            <div className={ReportClasses["Container"]}>
                {loading && <Loader />}
                <div className={ReportClasses["wrapper"]}>
                    <header>
                        <div>
                            <h3>Class Taken Report </h3>
                        </div>
                        <form
                            className={ReportClasses["filter"]}
                            onSubmit={handleSubmit(onSubmit)}>
                            <div className={ReportClasses["inputs"]}>
                                <input
                                    type="text"
                                    placeholder="From Date"
                                    {...register("StartDate", {
                                        required: true,
                                    })}
                                    onClick={(event) => {
                                        const inputElement = event.target;
                                        inputElement.type = "date";
                                    }}
                                />
                                <input
                                    type="text"
                                    placeholder="To Date"
                                    {...register("EndDate", {
                                        required: true,
                                    })}
                                    onClick={(event) => {
                                        const inputElement = event.target;
                                        inputElement.type = "date";
                                    }}
                                />
                                <Select
                                    options={tutors}
                                    onInputChange={handleTutorChange}
                                    value={selectedTutor}
                                    isClearable
                                    onChange={onTutorSelect}
                                    placeholder="Search Tutor"
                                    // noOptionsMessage={() => "No Student Found"}
                                    isLoading={tutorSearchLoad}
                                    styles={{
                                        // Set the width to 100%
                                        control: (provided) => ({
                                            ...provided,
                                            width: "100%",
                                        }),
                                    }}
                                />
                                {/*      <select
                                    {...register("Type", {
                                        required: true,
                                    })}>
                                    <option value="">Select Type</option>
                                    <option value="TUTOR">TUTOR</option>
                                    <option value="PARENT">PARENT</option>
                                    <option value="OTHERS">OTHERS</option>
                                </select> */}
                                <button>Submit</button>
                            </div>
                            {data.length > 0 && (
                                <div
                                    className={ReportClasses["downloadContent"]}
                                    style={{ overflow: "auto" }}>
                                    <button
                                        type="button"
                                        onClick={() =>
                                            window.open(link, "_blank")
                                        }>
                                        Export
                                    </button>
                                </div>
                            )}
                        </form>
                    </header>
                    {/*     <div className={ReportClasses["earnings"]}>
                        <div>
                            <p>No. of classes cancelled by the teacher </p>
                            <h3>{Teachers?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3 style={{ fontSize: "1.2rem" }}>
                                {Teachers?.ImpactedHours != 0 &&
                                    `${Teachers.ImpactedHours} Hour`}{" "}
                                {Teachers?.ImpactedMinutes != 0 &&
                                    `${Teachers.ImpactedMinutes} Minutes`}
                                {Teachers?.ImpactedMinutes == 0 &&
                                    Teachers?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                        <div>
                            <p>No. of classes cancelled by the parent</p>
                            <h3>{Parent?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3 style={{ fontSize: "1.2rem" }}>
                                {Parent?.ImpactedHours != 0 &&
                                    `${Parent.ImpactedHours} Hour`}{" "}
                                {Parent?.ImpactedMinutes != 0 &&
                                    `${Parent.ImpactedMinutes} Minutes`}
                                {Parent?.ImpactedMinutes == 0 &&
                                    Parent?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                        <div>
                            <p>No. of classes cancelled by the Others</p>
                            <h3>{Others?.NoOfClassesCancelled}</h3>
                            <p>(impacted hours)</p>
                            <h3
                                style={{
                                    color: "blue",
                                    fontSize: "1.2rem",
                                }}>
                                {Others?.ImpactedHours != 0 &&
                                    `${Others.ImpactedHours} Hour`}{" "}
                                {Others?.ImpactedMinutes != 0 &&
                                    `${Others.ImpactedMinutes} Minutes`}
                                {Others?.ImpactedMinutes == 0 &&
                                    Others?.ImpactedHours == 0 &&
                                    `0 Minutes`}
                            </h3>
                        </div>
                    </div> */}
                    <div className={ReportClasses["Tutor"]}>
                        <div className={ReportClasses["Table"]}>
                            <table style={{ minWidth: "1300px" }}>
                                <thead>
                                    <tr>
                                        <th>Teacher Name</th>

                                        <th>Batch Name</th>
                                        <th>Class Date</th>
                                        <th>Scheduled Start Time</th>
                                        <th>Scheduled End Time</th>

                                        <th>Scheduled Duration</th>
                                        <th>Actual Start Time</th>
                                        <th>Actual End Time</th>
                                        <th>Actual Duration</th>
                                        <th>Start Time Deviation</th>
                                        <th>End Time Deviation</th>
                                        <th>Duration Deviation</th>
                                        <th>In Class Duration</th>
                                        <th>Short Long Class</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentItems.length > 0 ? (
                                        currentItems.map((item, index) => {
                                            return (
                                                <tr>
                                                    <td>{item.TeacherName}</td>
                                                    <td>{item.BatchName}</td>

                                                    <td
                                                        style={{
                                                            width: "9rem",
                                                        }}>
                                                        {" "}
                                                        {moment(
                                                            item.ClassDate
                                                        ).format("DD-MM-YYYY")}
                                                    </td>

                                                    <td>
                                                        {
                                                            item.ScheduledStartTime
                                                        }
                                                    </td>
                                                    <td>
                                                        {item?.ScheduledEndTime}
                                                    </td>
                                                    <td>
                                                        {
                                                            item?.ScheduledDuration
                                                        }
                                                    </td>
                                                    <td>
                                                        {item.ActualStartTime}
                                                    </td>
                                                    <td>
                                                        {item.ActualEndTime}
                                                    </td>
                                                    <td>
                                                        {item.ActualDuration}
                                                    </td>
                                                    <td>
                                                        <span
                                                            style={{
                                                                color: !String(
                                                                    item.StartTimeDeviation
                                                                ).includes("-")
                                                                    ? "green"
                                                                    : String(
                                                                          item.StartTimeDeviation
                                                                      ).includes(
                                                                          "-"
                                                                      )
                                                                    ? "red"
                                                                    : "initial",
                                                            }}>
                                                            {
                                                                item.StartTimeDeviation
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            style={{
                                                                color: !String(
                                                                    item.EndTimeDeviation
                                                                ).includes("-")
                                                                    ? "green"
                                                                    : String(
                                                                          item.EndTimeDeviation
                                                                      ).includes(
                                                                          "-"
                                                                      )
                                                                    ? "red"
                                                                    : "initial",
                                                            }}>
                                                            {
                                                                item.EndTimeDeviation
                                                            }
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span
                                                            style={{
                                                                color: !String(
                                                                    item.DurationDeviation
                                                                ).includes("-")
                                                                    ? "green"
                                                                    : String(
                                                                          item.DurationDeviation
                                                                      ).includes(
                                                                          "-"
                                                                      )
                                                                    ? "red"
                                                                    : "initial",
                                                            }}>
                                                            {
                                                                item.DurationDeviation
                                                            }
                                                        </span>
                                                    </td>
                                                    <td
                                                        style={{
                                                            color: !String(
                                                                item.InClassDuration
                                                            ).includes("-")
                                                                ? "green"
                                                                : String(
                                                                      item.InClassDuration
                                                                  ).includes(
                                                                      "-"
                                                                  )
                                                                ? "red"
                                                                : "initial",
                                                        }}>
                                                        {item?.InClassDuration}
                                                    </td>
                                                    <td
                                                        style={{
                                                            color: !String(
                                                                item.ShortLongClass
                                                            ).includes("-")
                                                                ? "green"
                                                                : String(
                                                                      item.ShortLongClass
                                                                  ).includes(
                                                                      "-"
                                                                  )
                                                                ? "red"
                                                                : "initial",
                                                        }}>
                                                        {item?.ShortLongClass}
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={6}>
                                                {" "}
                                                no records Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div
                            style={{
                                justifySelf: "right",
                            }}>
                            <ReactPaginate
                                pageCount={Math.ceil(
                                    data.length / itemsPerPage
                                )}
                                marginPagesDisplayed={2}
                                onPageChange={handlePageChange}
                                breakClassName={"page-item"}
                                breakLinkClassName={"page-link"}
                                containerClassName={"pagination"}
                                pageClassName={"page-item"}
                                pageLinkClassName={"page-link"}
                                previousClassName={"page-item"}
                                previousLinkClassName={"page-link"}
                                nextClassName={"page-item"}
                                nextLinkClassName={"page-link"}
                                activeClassName={"active"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default Report;
